module.exports = __webpack_public_path__ + "img/NavigationDrawerBackground.31675b41.png";